module.exports = __webpack_public_path__ + "b3ae9952d018cd720da1d33c1000b339.svg";